import React from 'react';
import {Switch,Route,Redirect} from 'react-router-dom';
import Home from './Home';
import Contents from './Contents';
import Signin from './Signin';
import Login from './Login';
import AddContent from './AddContent';
import axios from 'axios'
import SearchContent from './SearchContent';
import Profile from './Profile';
import MyContents from './MyContents';
import AddTask from './AddTask';
import Tasks from './Tasks'

const SwitchControl = () =>{

    const connection = axios.create({
        baseURL:'https://ads-fatec-api.herokuapp.com',
        timeout:3000
    });

    (async function enableAPI(){
        const result = await connection.get("/");
        console.log(result.data.message);
    })();

    function setSuccessfulMessage(statusCode){
        return statusCode === 200 ? true : false
    }

    return(
        <Switch>
            <Route path="/Home">
                <Home connection={connection} setSuccessfulMessage={setSuccessfulMessage}/>
            </Route>
            <Route path="/Contents">
                <Contents connection={connection} setSuccessfulMessage={setSuccessfulMessage}/>
            </Route>
            <Route path="/AddContent">
                <AddContent connection={connection} setSuccessfulMessage={setSuccessfulMessage}/>       
            </Route>
            <Route path="/Login">
                <Login connection={connection} setSuccessfulMessage={setSuccessfulMessage}/>
            </Route>
            <Route path="/Signin">
                <Signin connection={connection} setSuccessfulMessage={setSuccessfulMessage}/>
            </Route>
            <Route path="/Content">
                <SearchContent connection={connection}/>
            </Route>
            <Route path="/Profile">
                <Profile connection={connection} setSuccessfulMessage={setSuccessfulMessage}/>
            </Route>
            <Route path="/MyContents">
                <MyContents connection={connection} setSuccessfulMessage={setSuccessfulMessage}/>
            </Route>
            <Route path="/AddTask">
                <AddTask connection={connection} setSuccessfulMessage={setSuccessfulMessage}/>
            </Route>
            <Route path="/Tasks">
                <Tasks connection={connection} setSuccessfulMessage={setSuccessfulMessage}/>
            </Route>
            <Redirect to="/Home"/>
        </Switch>
    )
}

export default SwitchControl;